import React, { Component } from "react";
import CartContext from "./CartContext";
import axios from "axios";
import { Card, Row, Col, Table } from "react-bootstrap";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

export default class RawMaterialsDashboard extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      summary: {},
      purchaseBySupplier: [],
      purchaseByMonth: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.loadDashboard();
  }

  loadDashboard = () => {
    const { storeId } = this.context;
    if (!storeId) return;

    axios
      .get(
        `${process.env.REACT_APP_API}RmDashboard/RawMaterialsSummary/${storeId}`
      )
      .then((res) => {
        this.setState({
          summary: {
            totalPurchases: res.data.totalPurchases || 0,
            totalPaidAmount: res.data.totalPaidAmount || 0,
            totalItemsPurchased: res.data.totalItemsPurchased || 0,
          },
          purchaseBySupplier: res.data.purchaseBySupplier || [],
          purchaseByMonth: res.data.purchaseByMonth || [],
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false });
      });
  };

  render() {
    const { summary, purchaseBySupplier, purchaseByMonth, loading } =
      this.state;

    if (loading) return <div>Loading...</div>;

    // Pie chart: Purchase by Supplier
    const supplierData = {
      labels: purchaseBySupplier.map((s) => s.supplier),
      datasets: [
        {
          label: "Purchase Amount by Supplier",
          data: purchaseBySupplier.map((s) => s.totalAmount),
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
          ],
        },
      ],
    };

    // Bar chart: Purchase by Month
    const monthData = {
      labels: purchaseByMonth.map((m) => m.month),
      datasets: [
        {
          label: "Monthly Purchase Amount",
          data: purchaseByMonth.map((m) => m.totalAmount),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
        },
      ],
    };

    return (
      <div className="container mt-1 text-center">
        {/* <h3 className="py-3">
          <b>Rawmaterials Purchase Summary - 360 View</b>
        </h3> */}
        {/* Summary Cards */}
        <Row className="mb-4">
          <Col md={4}>
            <Card className="p-3 text-center">
              <h5>Total Purchases</h5>
              <h3>{summary.totalPurchases}</h3>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="p-3 text-center">
              <h5>Total Paid Amount</h5>
              <h3>{summary.totalPaidAmount.toFixed(2)}</h3>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="p-3 text-center">
              <h5>Total Items Purchased</h5>
              <h3>{summary.totalItemsPurchased}</h3>
            </Card>
          </Col>
        </Row>

        {/* Charts */}
        <Row className="mb-4">
          <Col md={6}>
            <Bar
              data={monthData}
              options={{
                responsive: true,
                plugins: { legend: { display: false } },
              }}
            />
          </Col>
          <Col md={6}>
            <Pie data={supplierData} options={{ responsive: true }} />
          </Col>
        </Row>

        {/* Supplier Table */}
        <Row>
          <Col>
            <h5>Purchase Details by Supplier</h5>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Supplier</th>
                  <th>Total Purchase Amount</th>
                </tr>
              </thead>
              <tbody>
                {purchaseBySupplier.map((s, idx) => (
                  <tr key={idx}>
                    <td>{s.supplier}</td>
                    <td>{s.totalAmount.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}
